
import { UserManagerService } from './services/userManager/user-manager.service';
import { TimeHandlerService } from './time-handler.service';
import { Injectable, ɵConsole } from '@angular/core';
import * as SockJS from "sockjs-client"
import * as Stomp from 'stompjs';
import * as _ from 'lodash';
import { SkeletonServiceService } from '../components/skeleton-service.service';
import { ConfigService } from './config/config.service';
import { ModalService } from './modal-service/ModalService';
import { Subject } from 'rxjs';
import { RABBIT_CONFIG } from 'src/environments/environment';
import { Router } from '@angular/router';
// import { userLimitAttained } from '../mock-data/ws-msgs.data';
import { TranslateService } from '@ngx-translate/core';
@Injectable()
export class WebsocketService {

  stompClient: any;
  stompclient: any;
  cagnoteGames: any;
  getCagnote: Subject<[]> = new Subject();
  message: any;
  partants: any;
  connTimeout: any;
  checkIdletime = false;
  constructor(
    private configs: ConfigService,
    private userServices: UserManagerService,
    private modalService: ModalService,
    private router: Router,
    private skeletonServiceSkeletonService: SkeletonServiceService,
    private timeService: TimeHandlerService,
    private translate: TranslateService) {}

  private subject: any;
  subScriptionlist: any = {};

  validTypes: any = ['push-newtimelineevent', 'push-data', 'push-newodds', 'push-newmatch', 'push-betstop', 'push-newodds'];
  public connect() {
    // if (!this.stompclient) {
    //   const ws = new WebSocket(this.configs.PROXIES.Rabbit_Address);
    //   this.stompClient = Stomp.over(ws);
    // }
    // let ws = new SockJS(this.configs.PROXIES.Rabbit_Address);
    const ws = new WebSocket(this.configs.PROXIES.Rabbit_Address);
    // const accws = new WebSocket(PROXIES.AccRabbit_Address);
    // this.stompClient = Stomp.over(ws);
    this.stompClient = Stomp.over(ws);
    // const _this = this;
    this.stompClient.debug = null;
    // this.connectRabbit(this);

    // return this.subject;
  }
  public connect_session() {
    if (!this.stompClient) {
      const ws = new WebSocket(this.configs.PROXIES.Rabbit_Address);
      // let ws = new SockJS(this.configs.PROXIES.Rabbit_Address);
      this.stompClient = Stomp.over(ws);
      this.stompClient.debug = null;
    }

    this.connectRabbitSession(this);
  }

  public disconnect() {
    if (this.stompClient) {
      this.stompClient.disconnect(() => {
        this.stompClient = null;
      });
    }
    if (this.stompclient) {
      this.stompclient.disconnect(() => {
        this.stompclient = null;
      });
    }
    return this.subject;
  }
  async disconnectRabbitAuthenticatedUser() {
    if (this.stompClient) {
      if (this.stompclient.connected) {
        this.stompclient.unsubscribe('userQueue');
      }
    }
  }
  public connectRabbitAuthenticatedUser(context?) {
    const me = this;
    if (this.stompClient) {
      this.stompClient.subscribe('/exchange/betradarfeedsuof/betradarfeedsuof.client-listeners.status', (m) => {
        const reversedText = m.body.split('').join('');
        me.processMessage(JSON.parse(reversedText));
      });
      if (this.userServices.userData) {
        me.stompClient.subscribe('/exchange/betradarfeedsuof/flexbet.agent.' + this.userServices.userData.str_Account_Code, (m) => {
          const reversedText = m.body.split('').join('');
          me.processMessage(JSON.parse(reversedText));
        }, { id: "userQueue" });
      }
    } else {
      this.stompClient.connect('root', 'admin', (frame) => {
        this.stompClient.subscribe('/exchange/betradarfeedsuof/betradarfeedsuof.client-listeners.status', (m) => {
          const reversedText = m.body.split('').join('');
          me.processMessage(JSON.parse(reversedText));
        });
        if (this.userServices.userData) {
          me.stompClient.subscribe('/exchange/betradarfeedsuof/flexbet.agent.' + this.userServices.userData.str_Account_Code, (m) => {
            const reversedText = m.body.split('').join('');
            me.processMessage(JSON.parse(reversedText));
          });
        }

      }, (message) => {
        setTimeout(() => { me.connect(); }, 1000);

      }, '/');
    }
  }
  public subscribe(tail?) {
    if (!this.configs.lastmessagetime) {
      this.configs.lastmessagetime = new Date();
    }

    let route = '/exchange/betradarfeedsuof/betradarfeedsuof.client-listeners';
    const context = this;
    // route = tail ? route + '.' + tail  : route;
    route = tail ? route + '.' + tail + '.' + (this.skeletonServiceSkeletonService.viewInContext == 'LIVE' ? 'live' : 'pre') + '.#' : route;
    if (this.stompClient) {
      this.subScriptionlist[tail] = this.stompClient.subscribe(route, (m) => {
        const reversedText = m.body.split('').join('');
        context.processMessage(JSON.parse(reversedText));
      });
    }
  }
  public unsubscribe(tail?) {

  }
  private connectRabbit(me) {
    this.stompClient.connect(RABBIT_CONFIG.USER, RABBIT_CONFIG.PASSWD, (frame) => {
      // this.logger.log("subscibing to topic/messages")
      me.stompClient.subscribe("/topic/messages", function (m) {

        const reversedText = m.body.split('').join('');

        // me.logger.log("message received", JSON.stringify(m.body))
        me.processMessage(JSON.parse(reversedText));

      });
      this.subscribeFeedData(this);

    }, (message) => {
      // this.logger.log("Connection failed", message);
      setTimeout(() => { me.connect(); }, 5000);

    });

  }

  private connectRabbitSession(context) {
    // stompClient.debug = null;
    let me = this;
    // this.logger.log("reaching")
    this.stompClient.connect(RABBIT_CONFIG.USER, RABBIT_CONFIG.PASSWD, (frame) => {
      // this.logger.log("subscibing to topic/messages")
      if(this.userServices.userData && this.userServices.userData.account_code){
        me.stompClient.subscribe(`/exchange/${RABBIT_CONFIG.EXCHANGE}/${RABBIT_CONFIG.QUEUE + this.userServices.userData.account_code}`, function (m) {
          console.log('connectRabbitSession message', m);
          const reversedText = m.body.split('').join('');

          me.processMessage(JSON.parse(reversedText));

        });
        // setTimeout(() => {
        //   me.processMessage(JSON.parse(userLimitAttained));
        // }, 5000);
        this.subscribeFeedData(this);
      }

    }, (message) => {
      // this.logger.log("Connection failed", message);
      setTimeout(() => { me.connect(); }, 5000);

    });
  }

  subscribeFeedData(context) {
    let param = { "exchange": "betradarfeedsuof", "routine": "betradarfeedsuof.client-listeners", queue: "" }
    this.sendGlobal(param)
  }

  sendGlobal(message) {

    // this.logger.log("SENDING MESSAGE TO RABBIT", message)
    if (this.stompClient) {
      this.stompClient.subscribe(`/exchange/${message.exchange}/${message.routine}`, (m) => {
        const reversedText = m.body.split('').join('');
        this.processMessage(JSON.parse(reversedText));
      });
    } else {
      this.connTimeout = setTimeout(() => {
        this.sendGlobal(message);
      }, 5000);
    }
      // this.logger.log("Message Sent")
    // else{
    //   setTimeout(() => {
    //     this.sendGlobal(message);
    //   }, 5000);
    // }
  }
  subscribeToSessionExchange() {
    if (this.stompclient.connected)
      // if (this.userServices.userData && this.userServices.userData.account_code) {
      //   this.stompclient.subscribe(`/exchange/${RABBIT_CONFIG.EXCHANGE}/${RABBIT_CONFIG.QUEUE}.${this.userServices.userData.account_code}`, (m) => {
      //     const reversedText = m.body.split('').join('');
      //     // let message = JSON.parse(reversedText);
      //     // console.log("rabbit message", message)
      //     this.processMessage(reversedText)


      //   });
      // }
      if (this.userServices.userData) {
        let param = { exchange: this.configs.RABBIT_CONFIG.EXCHANGE, routine: this.configs.RABBIT_CONFIG.QUEUE + this.userServices.userData.account_code }
        this.sendGlobal(param)
      }
  }
  public disconnectUser() {
    if (this.stompclient) {
      this.stompclient.disconnect(() => {

      });
    }
    return this.subject;

  }

  async processMessage(rawMsg) {
    this.configs.lastmessagetime = new Date();
    if (typeof rawMsg === 'string' && (rawMsg.indexOf('hello received') > -1 || rawMsg.indexOf('message received')>-1))
      return;
    this.configs.lastmessagetime = new Date();
    const message = (typeof rawMsg === 'string') ? JSON.parse(rawMsg) : rawMsg;

    if (typeof message === 'string')
      return;

    if (message.hasOwnProperty('data') && message.data.hasOwnProperty('isExpired') && message.data.isExpired) {
      if (this.userServices.userData.session == message.data.session) {
        if (message.data.isForced) {
          // console.log('force logout')
          this.modalService.closeAllModals();
          this.router.navigate(['home']).then(() => {
            this.userServices.logout().then(() => {
              this.modalService.openSessionExpires().then((check) => {
                if(check.yesClicked){
                  this.router.navigate(['/user/login']);
                }
              });
            });
          });
        } else if(message.data.isExpired) {
          if(message.type === 'limit_attained'){
            this.updateLimitAttained(message);
          }
          if (this.userServices.userIdleTime < this.userServices.expireTime) {

            this.userServices.renewSession({ channel:3, lang: this.userServices.lang});

          } else {
            this.userServices.logout().then(() => {
              this.router.navigate(['/user/login']);
            });
          }

        }
      }
    }
    if (message.hasOwnProperty('data')) {
      switch (message.type) {
        case 'balance':
          this.updateBalance(message);
          break;
        case 'limit_attained':
          this.updateLimitAttained(message);
          break;
        default:
          break;
      }
      // this.userServices.userData.balances = message.data.balances
    }

  }



  processplatformStatus(message: any) {
    this.configs.bet_activated = message.data.status;
  }
  updateBalance(message: any) {
    this.userServices.updateUserAttribute('balances', message.data.balances);
  }

  updateLimitAttained(message: any) {
    const msg = message.data;
    if(msg.hasOwnProperty('period') && msg.hasOwnProperty('session') && msg.hasOwnProperty('isExpired') && msg.isExpired){
      this.modalService.openDialog('rg_limit_attained.title', 'rg_limit_attained.desc', false, true, null, 'OK').then((check) => {
        this.modalService.closeAllModals();
        if(check.yesClicked){
          this.userServices.logout().then(() => {
            this.router.navigate(['/user/login']);
          });
        }
      });
    }
  }

  updateMissingfields(outcome: any, outcome2: any) {
    const Keys = Object.keys(outcome);
    Keys.forEach(key => {
      if (!outcome2.hasOwnProperty(key)) {
        outcome2[key] = outcome[key];
      }
    });
  }
}
